import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Grid, IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TimePicker from "@mui/lab/TimePicker";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { ErrorOutlined } from "@mui/icons-material";
import Autocomplete from "@mui/material/Autocomplete";
import { withSnackbar } from "notistack";
import { getUsersByRole } from "../../../api/api";
import { useDataLists } from "../../../store/DataListsContextProvider";
import { v4 as uuidv4 } from "uuid";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  overflow: "hidden",
  cursor: "default",
};

const AddProcedureDialogue = (props) => {
  const { lists } = useDataLists();
  const [procedure, setProcedure] = useState({
    Procedure: props.procedure.Procedure ? props.procedure.Procedure : "",
    Name: props.procedure.Name ? props.procedure.Name : "",
    Surname: props.procedure.Surname ? props.procedure.Surname : "",
    Branch: props.procedure.Branch ? props.procedure.Branch : "",
    Radiologist: props.procedure.Radiologist ? props.procedure.Radiologist : "",
  });
  const [chosenProcedure, setChosenProcedure] = useState(procedure.Procedure);
  const [startTime, setStartTime] = useState(
    props.procedure.Time ? new Date(props.procedure.Time.FullStart) : null
  );
  const [endTime, setEndTime] = useState(
    props.procedure.Time ? new Date(props.procedure.Time.FullEnd) : null
  );
  const [selectOptions, setSelectOptions] = useState({
    radiologists: [],
  });
  const ALL_FIELDS_FILLED_IN =
    !Object.values(procedure).includes("") && startTime && endTime;
  const IS_UPDATE_ACTION = Boolean(props.procedure.Name);

  const handFieldChange = (e) => {
    setProcedure({
      ...procedure,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdateSelectValue = (val, type, isProcedureCode) => {
    if (isProcedureCode) {
      const proc = lists.procedures.find(
        (procedure) => procedure.Prefix === val
      );
      setProcedure({
        ...procedure,
        [type]: proc.Name,
      });
    } else {
      setProcedure({
        ...procedure,
        [type]: val ? val : "",
      });
    }
  };

  const handleClose = () => {
    setProcedure({
      Procedure: "",
      Name: "",
      Surname: "",
      Radiologist: "",
      Branch: "",
    });
    props.handleClose();
  };

  const handleCreateProcedure = () => {
    if (String(startTime) === "Invalid Date") {
      alert("Invalid start-time");
    } else if (String(endTime) === "Invalid Date") {
      alert("Invalid end-time");
    } else {
      const startHours = startTime.getHours();
      const endHours = endTime.getHours();
      const startMinutes = startTime.getMinutes();
      const endMinutes = endTime.getMinutes();

      const newProcadure = {
        ...procedure,
        Time: {
          FullStart: startTime,
          FullEnd: endTime,
          StartHours:
            String(startHours).length === 1
              ? "0" + String(startHours)
              : String(startHours),
          StartMinutes:
            String(startMinutes).length === 1
              ? "0" + String(startMinutes)
              : String(startMinutes),
          StartTimeFormat: String(startHours).length === 1 ? "am" : "pm",
          EndHours:
            String(endHours).length === 1
              ? "0" + String(endHours)
              : String(endHours),
          EndMinutes:
            String(endMinutes).length === 1
              ? "0" + String(endMinutes)
              : String(endMinutes),
          EndTimeFormat: String(endHours).length === 1 ? "am" : "pm",
        },
      };

      props.handleUpdateEvents(newProcadure, props.procedure.Id);
      handleClose();
    }
  };

  const getSelectOptions = async () => {
    const [radiologist_response] = await Promise.all([
      getUsersByRole("radiologist"),
    ]);

    let radiologists = [];

    const [radiologist_data, radiologist_err] = radiologist_response;

    if (radiologist_err) {
      props.enqueueSnackbar(radiologist_err.message, {
        preventDuplicate: true,
        variant: "error",
      });
      return;
    } else {
      radiologists = radiologist_data.data;
    }

    setSelectOptions({
      radiologists,
    });
  };

  const doNothing = () => {};

  useEffect(() => {
    try {
      getSelectOptions();
    } catch (err) {
      props.enqueueSnackbar(ErrorOutlined.message, {
        preventDuplicate: true,
        variant: "error",
      });
    }
  }, []);

  useEffect(() => {
    setChosenProcedure(
      lists.procedures.find((proc) => proc.Name === procedure.Procedure)
    );
  }, [procedure.Procedure]);

  return (
    <Box>
      <Modal
        open={props.open}
        onClose={doNothing}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              width: "100%",
              p: 1,
              pl: 2,
              boxShadow: 1,
              background: "#f44336",
              color: "#fff",
            }}
          >
            <Typography variant="h6">Add Procedure</Typography>
          </Box>

          <Box
            sx={{
              p: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid item sm={12}>
                <Typography variant="small" sx={{ color: "#fff" }}>
                  Fill in all fields
                </Typography>
              </Grid>

              <Grid item sm={12}>
                <CustomAutoComplete
                  label="Procedure Code"
                  type={"Procedure"}
                  isProcedureCode={true}
                  value={chosenProcedure ? chosenProcedure.Prefix : ""}
                  handleValueChange={handleUpdateSelectValue}
                  options={lists.procedures.map(
                    (procedure) => procedure.Prefix
                  )}
                />
              </Grid>

              <Grid item sm={12}>
                <CustomAutoComplete
                  label="Procedure Name"
                  type={"Procedure"}
                  value={chosenProcedure ? chosenProcedure.Name : ""}
                  handleValueChange={handleUpdateSelectValue}
                  options={lists.procedures.map((procedure) => procedure.Name)}
                />
              </Grid>

              <Grid item sm={6}>
                <TextField
                  fullWidth
                  name="Name"
                  label="Name"
                  variant="outlined"
                  onChange={handFieldChange}
                  value={procedure.Name}
                />
              </Grid>

              <Grid item sm={6}>
                <TextField
                  fullWidth
                  name="Surname"
                  label="Surname"
                  variant="outlined"
                  onChange={handFieldChange}
                  value={procedure.Surname}
                />
              </Grid>

              <Grid item sm={6}>
                <CustomAutoComplete
                  label={"Radiologist"}
                  type={"Radiologist"}
                  value={procedure.Radiologist}
                  handleValueChange={handleUpdateSelectValue}
                  options={selectOptions.radiologists.map(
                    (radiologist) =>
                      `${radiologist.FirstName} ${radiologist.LastName}`
                  )}
                />
              </Grid>

              <Grid item sm={6}>
                <CustomAutoComplete
                  label={"Branch"}
                  type={"Branch"}
                  value={procedure.Branch}
                  handleValueChange={handleUpdateSelectValue}
                  options={lists.branches.map((branch) => branch.Name)}
                />
              </Grid>

              <Grid item sm={12}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <TimePicker
                      value={startTime}
                      onChange={setStartTime}
                      renderInput={(params) => (
                        <TextField {...params} helperText="Start time" />
                      )}
                    />

                    <IconButton
                      sx={{
                        transform: "translateY(-10px)",
                      }}
                    >
                      <ArrowRightAltIcon />
                    </IconButton>

                    <TimePicker
                      value={endTime}
                      onChange={setEndTime}
                      renderInput={(params) => (
                        <TextField {...params} helperText="End time" />
                      )}
                    />
                  </Box>
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              p: 2,
              boxShadow: 1,
            }}
          >
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <Box sx={{ width: "100%" }}>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </Box>
              </Grid>
              <Grid item sm={6}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleCreateProcedure}
                    disabled={!ALL_FIELDS_FILLED_IN}
                  >
                    {IS_UPDATE_ACTION ? "Update" : "Add"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

const CustomAutoComplete = (props) => {
  return (
    <form
      sx={{
        width: "100%",
      }}
      autoComplete="nope"
    >
      <input
        autoComplete="nope"
        name="hidden"
        type="text"
        style={{ display: "none" }}
      />
      <Autocomplete
        options={props.options}
        onChange={(event, newValue) =>
          props.handleValueChange(newValue, props.type, props.isProcedureCode)
        }
        value={props.value}
        fullWidth
        autoHighlight
        getOptionLabel={(option) => option}
        renderOption={(props, option) => (
          <Box
            component="li"
            sx={{
              "& > img": { mr: 2, flexShrink: 0 },
            }}
            {...props}
            key={uuidv4()}
          >
            <Box sx={{ pl: 2, pr: 2 }}>{option}</Box>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            fullWidth
            autoComplete="nope"
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password", // disable autocomplete and autofill
            }}
          />
        )}
      />
    </form>
  );
};

export default withSnackbar(AddProcedureDialogue);
